import React from 'react';
import { debounce } from 'lodash';
import { TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';

const debouncedUpdate = debounce((updatedValueString, onChange) => onChange(updatedValueString), 200);

// Updated from original monorepo common-client2 component
const DebouncedTextField = ({ onChange, value, ...others }) => {
    const [displayedValue, setDisplayedValue] = useState(value);
    // MUI Textfield only receives one parameter
    const onValueChange = (ev, changedValue) => {
        debouncedUpdate(ev.target.value, onChange);
        setDisplayedValue(changedValue);
    };

    useEffect(() => setDisplayedValue(value), [value]);
    return (
        <TextField
            onChange={onValueChange}
            value={displayedValue}
            {...others}
        />
    );
};

export default DebouncedTextField;
